module.exports = __webpack_public_path__ + "img/corpo.372a9465.png";